<template>
	<div class="pagination">
		<div class="pages" v-if="pages > 1">
			<button
				v-for="( n, i ) in pagesRendered"
				:key="i"
				class="page"
				:disabled="n == null"
				:class="n == page ? 'selected' : ''"
				@click="click( n )"
			>
				{{ n === null ? '…' : n }}
			</button>
		</div>
		<div class="controls">
			<button :disabled="page == 1" :title="$t( 'pageFirst' )" @click="click( 1 )">
				<Icon symbol="triangleDouble" size="1.8em" />
			</button>
			<button :disabled="page == 1"  :title="$t( 'pagePrev' )" @click="click( page - 1 )">
				<Icon symbol="triangle" size="1.8em" />
			</button>
      <span
        class="input"

        :title="$t( 'pageCustom' )"
      >
        <input
          type="text"

          v-model="pageCustom"

          v-ok:enter="clickCustom"
        />
        <span
          class="button"
          @click="clickCustom()"
        >
        <Icon
          symbol="triangle"
          size="1.5em"
        />
        </span>
      </span>

      <span
        v-if="recount !== undefined"
      >
        <span
          class="button recount"
          @click="recount !== '' && $emit( 'recount', recount )"
          :title="$t( 'recount' )"
        >
          <Icon
            v-if="recount === null"
            class="icon"
            symbol="reload"
            size="0.8em"
          />
          <img
            v-else-if="recount === ''"
            src="../assets/imgs/loading.svg"
            class="loader"
            alt=""
          />
          <span v-else v-html="recount" />
        </span>
      </span>
			<button :title="$t( 'pageNext' )" :disabled="page == pages" @click="click( page + 1 )">
				<Icon symbol="triangle" size="1.8em" class="flipY" />
			</button>
			<button :disabled="page == pages" :title="$t( 'pageLast' )" @click="click( pages )">
				<Icon symbol="triangleDouble" size="1.8em" class="flipY" />
			</button>
		</div>
	</div>
</template>

<script>
  import Icon from "@/components/Icon";

	export default {
		name:  "PaginationUni",

		components: {
			Icon
		},

    i18n: {
      messages: {
        ru: {
          pageFirst:  "на первую страницу",
          pagePrev:   "на предыдущую страницу",
          pageNext:   "на следующую страницу",
          pageLast:   "на последнюю страницу",
          pageCustom: "на указанную страницу",
          recount:    "запросить кол-во страниц/элементов"
        },

        en: {
          pageFirst:  "to the first page",
          pagePrev:   "to the previous page",
          pageNext:   "to the next page",
          pageLast:   "to the last page",
          pageCustom: "to specified page",
          recount:    "request numbers of pages/items"
        },

        kz: {

          pageFirst:  "бірінші бетке",
          pagePrev:   "алдыңғы бетке оралу",
          pageNext:   "келесі бетке",
          pageLast:   "соңғы бетке",
          pageCustom: "көрсетілген бетке",
          recount:    "беттердің/элементтердің нөмірлерін сұрау"
        }
      }
    },

		props: {
			pages:	{
				type: Number,
				default: 1
			},
			page: {
				type: Number,
				default: 1
			},
			places: {
				type: Number,
				default: 6
			},
			edges: {
				type: Number,
				default: 3
			},
      /**
       * undefined  - button to recount items/pages is hidden
       * null       - button is showed
       * ""         - button is animated
       * text       - button shows this text
       */
      recount: {
			  type: String,
        default: undefined
      }
		},
		data() {
			return {
			  pageCustom: ""
			};
		},

		computed: {
			pagesRendered() {
				const l = [];
				const m = [];
				const r = [];

				if ( this.pages > 1 ) {
					let fr = null;
					let to = null;
	
					if ( this.pages <= this.places + this.edges + this.edges + 2 ) {
						fr = 1;
						to = this.pages;
					}
					else {
						if ( this.page <= this.places + this.edges - 1 ) {
							fr = 1;
							to = this.places + this.edges + 1;
						}
						else {
							for ( let i = 1; i <= this.edges; i++ ) l.push( i );
							l.push( null );
						}
	
						if ( fr === null && this.page > this.pages - this.places - this.edges ) {
							fr = this.pages - this.places - this.edges;
							to = this.pages;
						}
						else {
							r.push( null );
							for ( let i = this.pages - this.edges + 1; i <= this.pages; i++ ) r.push( i );
						}
	
						if ( fr === null || to === null ) {
							fr = this.page - ( this.places >> 1 );
							to = fr + this.places - 1;
						}
					}
	
					if ( fr <= 0 ) fr = 1;
					if ( to > this.pages ) to = this.pages;
					for ( let i = fr; i <= to; i++ ) m.push( i );
				}

				return l.concat( m, r );
			}
		},

		methods: {
			click( p ) {
				if ( p >= 1 && p <= this.pages ) {
					this.$emit( "page", p );
				}
			},

      clickCustom() {
			  const p = parseInt( this.pageCustom, 10 );
			  this.pageCustom = isNaN( p ) || p < 1 ? "" : p;
			  if ( p ) this.$emit( "page", p );
      }
		},
	};
</script>

<style scoped>
	.pagination {
		width: 20em;
		padding: 0.2em 1em;
		display: flex;
		align-items: flex-start;
		box-sizing: border-box;

    --activeBgColor: #FBE1E0;
    --activeColor: #E13833;
    --color: #E13833;
    --selectedBgColor: #E13833;
    --selectedColor: #FFFFFF;
  }

	.pagination > .pages {
    margin-right: auto;
  }

	.pagination > .pages > .page {
      border: none;
      background: none;
      cursor: pointer;
      padding: 0;
			border-radius: 0.2em;
			min-width: 1.5em;
			height: 1.2em;
			color: #E13833;
      transition: opacity .35s ease;
      margin: 0.2em;
  }

  .pagination > .pages > .page:disabled {
    pointer-events: none;
  }

  .pagination > .pages > .page:hover,
  .pagination > .pages > .page:focus {
    background-color: var(--activeBgColor);
    color: var(--activeColor);
  }

  .pagination > .pages > .page.selected {
    background-color: var(--selectedBgColor);
    color: var(--selectedColor);
	}

  .pagination button {
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    min-width: 1.5em;
    height: 1.8em;
    border-radius: 0.2em;
  }

  .pagination button * {
    fill: var(--color);
    color: var(--color);
  }

  .pagination button:nth-child(2) {
    margin-right: 0.5em;
  }

  .pagination button:disabled {
		opacity: .5;
		pointer-events: none;
  }

  .pagination button:hover {
    background-color: var(--activeBgColor);
  }

  .pagination .flipY {
		transform: scaleX(-1);
  }

  .pagination .controls {
    white-space: nowrap;
  }
  .pagination .controls * {
    vertical-align: middle;
  }
  .pagination .controls .input {
    display: inline-block;
    border: solid 1px var(--selectedBgColor);
    border-radius: 0.2em;
    margin: 0 0.2em;
    position: relative;
    top: 0.1em;
    width: 3.4em;
    background-color: #FFFFFF;
    font-size: 0.8em;
  }
  .pagination .controls .input input {
    display: inline-block;
    margin: 0 0.2em;
    border: unset;
    padding: 0;
    box-sizing: border-box;
    width: 1.9em;
    font: inherit;
    color: var(--activeColor);
  }
  .pagination .controls .input .button {
    background-color: var(--selectedBgColor);
    position: absolute;
    right: 0;
    top: -1px;
    bottom: -1px;
    width: 1.1em;
    border-radius: 0 0.2em 0.2em 0;
    overflow: hidden;
    cursor: pointer;
  }
  .pagination .controls .input .button > * {
    position: absolute;
    top: 0.1em;
    left: -0.1em;
    transform: scale( -1 );
    fill: #FFFFFF;
  }
  .pagination .controls .input .button:active > * {
    margin: 1px 0 0 1px;
  }
  .pagination .controls .input .button:hover {
    opacity: 0.8;
  }

  .pagination .controls .recount {
    display: inline-block;
    position: relative;
    cursor: pointer;
    border-radius: 0.2em;
    background-color: var(--selectedBgColor);
    color: var(--selectedColor);
    padding: 0 0.2em;
    vertical-align: middle;
    min-width: 1.5em;
    height: 1.25em;
    text-align: center;
  }
  .pagination .controls .recount > .icon {
    position: absolute;
    transform: translate( -50%, -50% );
    top: 50%;
    left: 50%;
  }
  .pagination .controls .recount:active > .icon {
    margin: 1px 0 0 1px;
  }
  .pagination .controls .recount > .loader {
    display: inline-block;
    position: absolute;
    transform: translate( -50%, -50% );
    top: 50%;
    left: 50%;
    width: 1em;
    filter: invert( 1 );
  }
  .pagination .controls .recount > span {
    font-size: 0.9em;
    vertical-align: baseline;
    font-weight: bold;
  }
</style>
